import { FormikProvider, useFormik } from 'formik';
import { isEqual, pick } from 'lodash';
import * as yup from 'yup';
import { useUpdateEntityContactPaymentDetailsMutation } from '@/modules/investor-dashboard/queries/entity.ts';
import { Button, TextInputField } from 'ui';
import { EntityWithDocumentResponse } from 'api';

export type entityEditableData = Pick<
  EntityWithDocumentResponse,
  'bank_account_bsb' | 'bank_account_name' | 'bank_account_number' | 'bank_name'
>;

const validationSchema = yup.object({
  bank_name: yup.string().trim().required('This field is required'),
  bank_account_bsb: yup.string().trim().required('This field is required'),
  bank_account_name: yup.string().trim().required('This field is required'),
  bank_account_number: yup.string().trim().required('This field is required'),
});

export interface EditEntityPaymentTabProps {
  onSuccess?: () => void;
  entity: EntityWithDocumentResponse;
}

export const EditEntityPaymentTab = ({ onSuccess, entity }: EditEntityPaymentTabProps) => {
  const { mutateAsync, isLoading } = useUpdateEntityContactPaymentDetailsMutation({ onSuccess });

  const formik = useFormik<entityEditableData>({
    validationSchema,
    initialValues: pick(entity, [
      'bank_account_bsb',
      'bank_account_name',
      'bank_account_number',
      'bank_name',
    ]),
    onSubmit: async values => {
      await mutateAsync({ ...values, id: entity.id });
    },
  });

  const isChanged = !isEqual(formik.values, formik.initialValues);

  return (
    <FormikProvider value={formik}>
      <div className="py-4">
        <div className="flex flex-col gap-8">
          <TextInputField name="bank_name" label="Bank name" />
          <TextInputField name="bank_account_bsb" label="BSB" placeholder="123-123" />
          <TextInputField name="bank_account_number" label="Account number" />
          <TextInputField name="bank_account_name" label="Account name" />
        </div>
      </div>
      <Button
        loading={isLoading}
        disabled={
          !isChanged || isLoading || Object.values(formik.errors).filter(item => !!item).length > 0
        }
        onClick={formik.handleSubmit}
        type="submit"
      >
        Save changes
      </Button>
    </FormikProvider>
  );
};
